const globals = (
  state = {
    layout: 'default',
    hrefLang: {
      start: {},
    },
    campaigns: {
      active: [],
    },
    campaignBanners: {
      active: [],
    },
    cookieBanner: {
      version: undefined,
    },
  },
  action
) => {
  switch (action.type) {
    case '__DANGEROUS_CONFIG_RECEIVE': {
      const marketKeys = Object.keys(action.markets).filter(
        market =>
          action.markets[market].active && action.markets[market].translation
      );

      return {
        ...state,
        hrefLang: {
          ...state.hrefLang,
          start: marketKeys.reduce(
            (all, market) =>
              Object.assign(all, {
                [action.markets[market].translation.replace(
                  '_',
                  '-'
                )]: `${action.markets[market].sites.production}/`,
              }),
            {
              en: `${action.markets.gb.sites.production}/`,
              // Render x-default href lang tag only on start page.
              // Recommendation from Schibsted SEO-guru.
              'x-default': `${action.markets.gb.sites.production}/`,
            }
          ),
          campaignMain: marketKeys
            .filter(
              market =>
                action.markets[market].url &&
                action.markets[market].url.campaigns
            )
            .reduce(
              (all, market) =>
                Object.assign(all, {
                  [action.markets[market].translation.replace(
                    '_',
                    '-'
                  )]: `${action.markets[market].sites.production}${action.markets[market].url.campaigns}`,
                }),
              {
                en: `${action.markets.gb.sites.production}${action.markets.gb.url.campaigns}`,
              }
            ),
        },
      };
    }

    case 'APP_STARTUP': {
      const { renderContext } = window.dataLayer[0];

      switch (renderContext) {
        case 'responsive':
        case 'beta':
        case 'mobile':
        case 'native':
          return state;
        case 'desktop': {
          // if pjcua isn't set it will return null. We'll need cookie to
          // be set to undefined for the cookie banner to be displayed
          return {
            ...state,
            cookieBanner: {
              version: localStorage.getItem('pjcua') || undefined,
            },
          };
        }
        default:
      }
      break;
    }

    case 'SESSION_RECEIVE': {
      return {
        ...state,
        cookieBanner: {
          version: action.session.cookie_consent_version,
        },
      };
    }
    case 'ACCEPT_COOKIES': {
      const { renderContext } = window.dataLayer[0];

      if (renderContext === 'desktop') {
        localStorage.setItem('pjcua', action.version);
      }
      return {
        ...state,
        cookieBanner: {
          version: action.version,
        },
      };
    }

    case 'CAMPAIGNS_RECEIVE': {
      return {
        ...state,
        campaigns: {
          active: action.campaigns.filter(c => c.state === 'ACTIVE'),
        },
        campaignBanners: {
          active: action.campaigns.reduce(
            (allBanners, campaign) =>
              allBanners.concat(
                campaign.banners.map(banner => ({ ...banner, campaign }))
              ),
            []
          ),
        },
      };
    }

    case 'FILTER_TOGGLE_MOBILE': {
      return {
        ...state,
        layout: action.open ? 'raw-mobile' : 'default',
      };
    }

    case 'BRAND_MEDIA_TOGGLE':
    case 'PRODUCT_MEDIA_OPEN': {
      return {
        ...state,
      };
    }
    default:
    // Do nothing
  }
  return state;
};

export default globals;
